import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './assets/main.scss' // Import global styles
import logoUrl from '@/assets/logo.png'

// // ERP 子域名重定向：若访问 e.xxxx（如 e.localhost 或 e.zimimodel.net），自动跳转至 ERP 系统
// if (window.location.hostname.startsWith('e.')) {
//   window.location.replace('http://zmmdkjerp.gnway.cc/sysn/view/init/login.ashx')
// }

/**
 * 应用入口（Vue 3 + TypeScript）
 * - 责任：挂载根组件、注册路由与状态管理、应用全局样式。
 * - 历史要求记录：
 *   1) 页面标题需为“子米模型”，现改为在 public/index.html 静态设置，避免运行时重复赋值；
 *   2) favicon 指向 src/assets/logo.png，并在运行时注入 <link rel="icon" type="image/png">，兼容开发与打包后路径。
 * - 说明：浏览器标签栏 favicon 显示尺寸固定（常见 16×16；视网膜 32×32）。若需更清晰，可提供多尺寸资源或生成 favicon.ico。
 */
// 设置 favicon（历史要求：标题设为“子米模型”，现由 index.html 静态设置，避免重复）
const faviconLink = (document.querySelector("link[rel='icon']") as HTMLLinkElement) || document.createElement('link')
faviconLink.rel = 'icon'
faviconLink.type = 'image/png'
faviconLink.href = logoUrl
if (!faviconLink.parentNode) document.head.appendChild(faviconLink)

createApp(App).use(store).use(router).mount('#app')
